import { ReportEntityType, ReportWorkbook } from 'components/ReportsModule/types';
import { CLASSROOM_WORKBOOK } from './classroom';
import { EDUCATOR_WORKBOOK } from './educator';
import { ORGANIZATION_WORKBOOK } from './organization';
import { STUDENT_WORKBOOK } from './student';

const KEY_REPORT_EXPORT_MAP: { [key in ReportEntityType]?: ReportWorkbook<any> } = {
  [ReportEntityType.DISTRICT]: ORGANIZATION_WORKBOOK[ReportEntityType.DISTRICT],
  [ReportEntityType.SCHOOL]: ORGANIZATION_WORKBOOK[ReportEntityType.SCHOOL],
  [ReportEntityType.USER_GROUP]: ORGANIZATION_WORKBOOK[ReportEntityType.USER_GROUP],
  [ReportEntityType.CLASSROOM]: CLASSROOM_WORKBOOK,
  [ReportEntityType.USER]: EDUCATOR_WORKBOOK,
  [ReportEntityType.STUDENT]: STUDENT_WORKBOOK
};

export default KEY_REPORT_EXPORT_MAP;
